<script>
// Extensions
import View from "@/views/View";

// Mixins
import LoadSections from "@/mixins/load-sections";

export default {
  name: "Pegadaian",

  metaInfo: { title: "Pegadaian" },

  extends: View,

  mixins: [LoadSections(["pegadaian", "info"])],

  props: {
    id: {
      type: String,
      default: "pegadaian"
    }
  }
};
</script>
